import  React, { Component } from "react";
import { LandingPageComponent } from "./LandingPageComponent";
import { IntlProvider } from "react-intl";
import { messages } from './en-US';

class App extends Component {
    render() {
      window.parent.postMessage(JSON.stringify({
        action: "updateHeight",
        height: 650,
      }), "*");

      return (
            <IntlProvider locale={'en'} key={'en'} messages={messages}>
                <LandingPageComponent/>
            </IntlProvider>
      );
    }
  }

export default App;
